export const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const waitForSlideRender = (
  rootEl,
  expectedSlideId,
  { timeoutMs = 4000, pollIntervalMs = 16 } = {}
) => new Promise((resolve, reject) => {
  const startedAt = Date.now();

  const poll = () => {
    if (!rootEl || !rootEl.isConnected) {
      reject(new Error('PDF export surface is unavailable'));
      return;
    }

    const selector = `[data-slide-id="${expectedSlideId}"]`;
    const renderedSlide = rootEl.matches && rootEl.matches(selector)
      ? rootEl
      : rootEl.querySelector(selector);

    if (renderedSlide) {
      resolve(renderedSlide);
      return;
    }

    if (Date.now() - startedAt >= timeoutMs) {
      reject(new Error(`Timed out waiting for slide ${expectedSlideId} to render`));
      return;
    }

    setTimeout(poll, pollIntervalMs);
  };

  poll();
});

export const waitForDocumentFonts = async (doc = document) => {
  if (doc && doc.fonts && doc.fonts.ready) {
    try {
      await doc.fonts.ready;
    } catch (error) {
      // Ignore font loading failures and continue with export.
    }
  }
};

export const waitForImages = async (rootEl) => {
  if (!rootEl) return;

  const images = Array.from(rootEl.querySelectorAll('img'));
  await Promise.all(images.map((img) => new Promise((resolve) => {
    if (img.complete) {
      resolve();
      return;
    }

    const finish = () => {
      img.removeEventListener('load', finish);
      img.removeEventListener('error', finish);
      resolve();
    };

    img.addEventListener('load', finish, { once: true });
    img.addEventListener('error', finish, { once: true });
  })));
};

export const waitForAnimationFrames = (count = 2) => new Promise((resolve) => {
  const step = (remaining) => {
    if (remaining <= 0) {
      resolve();
      return;
    }

    if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(() => step(remaining - 1));
      return;
    }

    setTimeout(() => step(remaining - 1), 16);
  };

  step(count);
});
